module.exports = __webpack_public_path__ + "static/media/laptop.23458f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/laptop.jpg
// module id = 151
// module chunks = 2